import React from 'react';
import { B as Button } from './Button-DJQVVE0-.js';

function ButtonDismiss({ onClick, ariaLabel }) {
    return (React.createElement(Button, { ariaLabel: ariaLabel, icon: "remove", onClick: onClick, type: "tertiary", variation: "subtle" }));
}

export { ButtonDismiss as B };
